export interface IndividualPlanContent {
	catalogId: string;
	philosophy: string; // 2-3 líneas narradas
	philosophyTagline: string; // ej. "Filosofía indexada"
	targetInvestor: string; // ¿A quién va dirigido?
	riskProfile: number; // 1-7
	dfpUrl?: string; // URL al DFP, opcional
}

export const INDIVIDUAL_PLANS_CONTENT: Record<string, IndividualPlanContent> = {
	'indexa-mas-rentabilidad-acciones-ppi': {
		catalogId: 'indexa-mas-rentabilidad-acciones-ppi',
		philosophy:
			'Replica los principales índices del mundo. La rentabilidad acompaña al mercado a largo plazo y las comisiones son las más bajas del catálogo.',
		philosophyTagline: 'Filosofía indexada',
		targetInvestor:
			'Encaja con quien confía en que el mercado sube a largo plazo y prefiere el menor coste posible.',
		riskProfile: 5,
		dfpUrl: 'https://storage.googleapis.com/arca-plans-documents/DFP/DFP_indexa-acciones.pdf'
	},
	'horos-internacional-pp': {
		catalogId: 'horos-internacional-pp',
		philosophy:
			'Un equipo gestor analiza empresas a nivel global y selecciona las que considera infravaloradas. Comisiones más altas a cambio de gestión activa.',
		philosophyTagline: 'Filosofía value internacional',
		targetInvestor:
			'Encaja con quien cree que un equipo gestor experto puede batir al mercado seleccionando bien.',
		riskProfile: 5,
		dfpUrl: 'https://storage.googleapis.com/arca-plans-documents/DFP/DFP_horos-internacional.pdf'
	},
	'caser-magallanes-pp': {
		catalogId: 'caser-magallanes-pp',
		philosophy:
			'Mismo enfoque value, centrado en empresas europeas. Equipo gestor con trayectoria reconocida en este estilo.',
		philosophyTagline: 'Filosofía value europeo',
		targetInvestor: 'Encaja con quien quiere apostar por value pero con foco en mercado europeo.',
		riskProfile: 6,
		dfpUrl: 'https://storage.googleapis.com/arca-plans-documents/DFP/DFP_magallanes.pdf'
	}
};
